/* tslint:disable */
/* eslint-disable */

/**
 * 805290000 = Website (Website)
 * 
 * 805290001 = EminusMail (E-Mail)
 * 
 * 805290002 = Facebook (Facebook)
 * 
 * 805290003 = Internetsuche (Internetsuche)
 * 
 * 805290004 = Instagram (Instagram)
 * 
 * 805290005 = Nachrichten (Nachrichten)
 * 
 * 805290006 = PersonlicheEmpfehlung (Persönliche Empfehlung)
 * 
 * 805290007 = YouTube (YouTube)
 * 
 * 805290008 = Sonstiges (Sonstiges)
 */
import {EnumValue} from "@/core/models/enumvalue.model"
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export enum GlobalEnumsAceInformationsquelle {
 Website = 805290000,
 EminusMail = 805290001,
 Facebook = 805290002,
 Internetsuche = 805290003,
 Instagram = 805290004,
 Nachrichten = 805290005,
 PersonlicheEmpfehlung = 805290006,
 YouTube = 805290007,
 Sonstiges = 805290008
}

marker([
    "Enum.GlobalEnumsAceInformationsquelle.Website",
    "Enum.GlobalEnumsAceInformationsquelle.EminusMail",
    "Enum.GlobalEnumsAceInformationsquelle.Facebook",
    "Enum.GlobalEnumsAceInformationsquelle.Internetsuche",
    "Enum.GlobalEnumsAceInformationsquelle.Instagram",
    "Enum.GlobalEnumsAceInformationsquelle.Nachrichten",
    "Enum.GlobalEnumsAceInformationsquelle.PersonlicheEmpfehlung",
    "Enum.GlobalEnumsAceInformationsquelle.YouTube",
    "Enum.GlobalEnumsAceInformationsquelle.Sonstiges"
]);

export namespace GlobalEnumsAceInformationsquelle
{
    class DataSets
    {
        static GlobalEnumsAceInformationsquelleDataSet: Array<EnumValue> = new Array<EnumValue>(
            new EnumValue("Website", 805290000, "Website"),
            new EnumValue("EminusMail", 805290001, "E-Mail"),
            new EnumValue("Facebook", 805290002, "Facebook"),
            new EnumValue("Internetsuche", 805290003, "Internetsuche"),
            new EnumValue("Instagram", 805290004, "Instagram"),
            new EnumValue("Nachrichten", 805290005, "Nachrichten"),
            new EnumValue("PersonlicheEmpfehlung", 805290006, "Persönliche Empfehlung"),
            new EnumValue("YouTube", 805290007, "YouTube"),
            new EnumValue("Sonstiges", 805290008, "Sonstiges"),
        )
    }

    export function getAsDataset() {
        return DataSets.GlobalEnumsAceInformationsquelleDataSet;
    }
}
